module.exports = __webpack_public_path__ + "img/icon-telegram.aa24101d.svg";